// ==============================|| OVERRIDES - TABLE CELL ||============================== //

export default function DataGridTableCell(theme) {
    return {
        MuiDataGrid: {
            styleOverrides: {
                cell: {
                    fontSize: '0.875rem',
                    padding: 12,
                    borderColor: theme.palette.divider
                },
                columnHeader: {
                    fontSize: '0.875rem',
                    fontWeight: 600
                },
                iconSeparator: {
                    color: theme.palette.divider
                },
                head: {
                    fontWeight: 600,
                    paddingTop: 20,
                    paddingBottom: 20
                }
            }
        }
    };
}
